export default __webpack_public_path__ + "fonts/angles-right-regular.svg";